import React, { useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  GlobalStyles, // For overriding the default cropper CSS
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Loader from "./Loader";

// These styles will HIDE the default square crop box, making it truly look circular.
const cropperGlobalStyles = (
  <GlobalStyles
    styles={{
      ".cropper-view-box": {
        borderRadius: "50%", // Make the view box circular
        outline: "none", // Hide the default outline
        boxShadow: "none", // Hide the default shadow
      },
      ".cropper-face": {
        borderRadius: "50%", // Make the draggable face circular
        opacity: 0.1, // Make it slightly visible for dragging
        backgroundColor: "#fff",
      },
      // Hide the dashed lines
      ".cropper-dashed": {
        display: "none",
      },
      // Hide the grid lines
      ".cropper-line": {
        display: "none",
      },
      // Hide the resize handles
      ".cropper-point": {
        display: "none",
      },
    }}
  />
);

const CircularImageCropper = ({ open, image, onCrop, onCancel, loading }) => {
  const cropperRef = useRef(null);

  // This function takes the square data and clips it into a circular file. It's correct.
  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (typeof cropper === "undefined") {
      return;
    }

    const canvas = cropper.getCroppedCanvas({ width: 500, height: 500 });
    const circularCanvas = document.createElement("canvas");
    circularCanvas.width = 500;
    circularCanvas.height = 500;
    const ctx = circularCanvas.getContext("2d");

    ctx.beginPath();
    ctx.arc(250, 250, 250, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(canvas, 0, 0);

    circularCanvas.toBlob(
      (blob) => {
        if (blob) {
          const file = new File([blob], "profileImage.png", {
            type: "image/png",
          });
          onCrop(file);
        }
      },
      "image/png",
      0.95,
    );
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      {/* This is the key to making it look circular! */}
      {cropperGlobalStyles}

      {loading && <Loader />}
      <DialogTitle>Move and Scale</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            position: "relative",
            height: 350,
            width: "100%",
            backgroundColor: "black",
          }}
        >
          <Cropper
            ref={cropperRef}
            src={image}
            style={{ height: "100%", width: "100%" }}
            // --- Configuration for a perfect circular editor ---
            viewMode={3} // *** This allows zooming out freely ***
            aspectRatio={1}
            dragMode="move"
            guides={false}
            background={false}
            autoCropArea={1}
            cropBoxMovable={false}
            cropBoxResizable={false}
            toggleDragModeOnDblclick={false}
          />
        </Box>
        {/* A slider provides a much better UX for zooming than just the mouse wheel */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleCrop} color="primary" variant="contained">
          Crop
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CircularImageCropper;
